import React, { useEffect, useContext, useState } from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { useLocation, useNavigate, Outlet } from 'react-router-dom';

import Typography from '@mui/material/Typography';
import Toolbar from '@mui/material/Toolbar';

import TabContainer from 'containers/TabContainer/TabContainer';
import ContextStore from 'modules/context';

function SettingAppointment() {
  const { formatMessage } = useIntl()
  const navigate = useNavigate()
  const { setBreadcrumbs } = useContext(ContextStore)
  const location = useLocation()
  const pathname = location.pathname
  const [activeTabIndex, setActiveTabIndex] = useState(undefined)

  let defaultSelect
  if (pathname === '/setting/appointment/treatments') {
    defaultSelect = 0
  } else if (pathname === '/setting/appointment/rooms') {
    defaultSelect = 1
  } else if (pathname === '/setting/appointment/salesReps') {
    defaultSelect = 2
  }

  useEffect(() => {
    setBreadcrumbs([{
      text: formatMessage({ id: 'sideMenu.setting.root' })
    }])
  }, [pathname]);

  useEffect(() => {
    if (pathname === '/setting/appointment/treatments' && activeTabIndex !== 0) {
      setActiveTabIndex(0)
    } else if (pathname === '/setting/appointment/rooms' && activeTabIndex !== 2) {
      setActiveTabIndex(1)
    } else if (pathname === '/setting/appointment/salesReps' && activeTabIndex !== 3) {
      setActiveTabIndex(2)
    }

    return () => {
    };
  }, [pathname]);

  const onTabSelected = (tabIndex) => {
    if (tabIndex === 0) {
      navigate('/setting/appointment/treatments');
    } else if (tabIndex === 1) {
      navigate('/setting/appointment/rooms');
    } else if (tabIndex === 2) {
      navigate('/setting/appointment/salesReps');
    }
  }

  const tabs = [
    {
      label: formatMessage({ id: 'setAppointment.treatments.table.title' }),
      component: <Outlet />
    },
    {
      label: formatMessage({ id: 'setAppointment.rooms.table.title' }),
      component: <Outlet />
    },
    {
      label: formatMessage({ id: 'setAppointment.salesReps.table.title' }),
      component: <Outlet />
    }
  ]

  return (
    <div style={{ padding: '12px 24px 80px 24px' }}>
      <Toolbar sx={{ pl: 2, pr: 1 }}>
        <Typography sx={{ flex: '1 1 100%', flexShrink: 2 }} variant="h6" id="tableTitle" component="div">
          <FormattedMessage id="setAppointment.title" />
        </Typography>
      </Toolbar>
      <TabContainer activeTabIndex={activeTabIndex} defaultSelect={defaultSelect} tabs={tabs} onTabSelected={onTabSelected} />
    </div>
  );
}

export default SettingAppointment;
